export default "27da065170d89ad4d37994e96989bd2b.png";